import React, { useCallback } from "react"
import { useTheme } from "styled-components"

import totalNavHeight from "utils/totalNavHeight"

import ImagePreload from "components/image-preload"
import HeroContent from "../content"
import {
  Container,
  Content,
  Arrow,
  Timer,
  BackgroundImage,
  ButtonsContainer,
  OneButtonContainer,
  Metrics,
  Metric,
} from "./styles"
import { Overlay } from "../banner/styles"

const CenteredHero = ({
  heading,
  preheading,
  subheading,
  anchorTarget,
  countdownDate,
  backgroundImages,
  minHeight,
  metrics,
  buttonElement,
  secondaryButtonElement,
  alternate,
  hasOverlay,
  elRef,
  signupForm,
  contentStyles,
  containerStyles,
  contentProps,
  dataId,
  hideOnPageLoad,
  ...props
}) => {
  const theme = useTheme()

  const onAnchorClick = useCallback(() => {
    window.history.pushState({}, "", anchorTarget)
    const element = document.querySelector(anchorTarget)
    if (element) {
      window.scrollTo({
        top: element.offsetTop - totalNavHeight(),
        left: 0,
        behavior: "smooth",
      })
    }
  }, [anchorTarget])

  const bgImages = backgroundImages && [
    {
      screenSize: 1200,
      url: backgroundImages.desktop,
      transforms: `c_fill,g_auto,w_1440,h_${minHeight || 700},q_auto,f_auto,fl_lossy`,
    },
    {
      screenSize: 1024,
      url: backgroundImages.desktop,
      transforms: `c_fill,g_auto,w_1200,h_${minHeight || 700},q_auto,f_auto,fl_lossy`,
    },
    {
      screenSize: 768,
      url: backgroundImages.desktop,
      transforms: `c_fill,g_auto,w_1024,h_${minHeight || 800},q_auto,f_auto,fl_lossy`,
    },
    {
      screenSize: 500,
      url: backgroundImages.tablet,
      transforms: `c_fill,g_auto,w_768,h_${minHeight || 700},q_auto,f_auto,fl_lossy`,
    },
    {
      url: backgroundImages.mobile,
      transforms: `c_fill,g_auto,w_500,h_${minHeight || 800},q_auto,f_auto,fl_lossy`,
    },
  ]

  return (
    <Container
      hideOnPageLoad={hideOnPageLoad}
      data-exp-id={dataId}
      ref={elRef}
      alternate={alternate}
      minHeight={minHeight}
      style={containerStyles}
    >
      {bgImages && theme.component.onTop && <ImagePreload images={bgImages} />}
      {bgImages && <BackgroundImage images={bgImages} alt="" lazy={!theme.component.onTop} />}
      {hasOverlay && <Overlay />}
      <Content
        {...contentProps}
        onClick={anchorTarget && !buttonElement ? onAnchorClick : null}
        alternate={alternate}
        {...props}
        style={contentStyles}
      >
        {countdownDate && <Timer targetDate={countdownDate} />}
        <HeroContent preheading={preheading} heading={heading} body={subheading} />
        {secondaryButtonElement ? (
          <ButtonsContainer>
            {buttonElement}
            {secondaryButtonElement}
          </ButtonsContainer>
        ) : (
          buttonElement && <OneButtonContainer>{buttonElement}</OneButtonContainer>
        )}
        {signupForm}
        {metrics && (
          <Metrics numMetrics={metrics.length}>
            {metrics.map((m) => (
              <Metric key={m.id}>
                <h5>{m.value}</h5>
                <span>{m.label}</span>
              </Metric>
            ))}
          </Metrics>
        )}
        {anchorTarget && !buttonElement && <Arrow />}
      </Content>
    </Container>
  )
}

export default CenteredHero
